export default "__VITE_ASSET__CBAsQRA___"